import React from "react";
import { isApp, isHaojieSDK } from "tools/utils";
// 异步加载文件 参考文档 https://webpack.js.org/guides/code-splitting/#dynamic-imports
// 参数中的注释部分不建议删除，原因请看上述文档
const AgreeContext = () => import("./containers/accredit/AgreeContext" /* webpackChunkName:"AgreeContext" */);
const BlankPage = () => import("./containers/accredit/BlankPage" /* webpackChunkName:"BlankPage" */);

const FaqList = () => import("./containers/withdraw/FaqList/index" /* webpackChunkName:"FaqList" */);
const FaqDetail = () => import("./containers/withdraw/FaqDetail/index" /* webpackChunkName:"FaqDetail" */);

const RepayResult = () => import("./containers/repay/RepayResult/index" /* webpackChunkName:"RepayResult" */);
const BorrowRecord = () => import("./containers/repay/BorrowRecord/index" /* webpackChunkName:"BorrowRecord" */);
const BorrowDetail = () => import("./containers/repay/BorrowDetail/index" /* webpackChunkName:"BorrowDetail" */);
const BorrowUse = () => import("./containers/repay/BorrowUse/index" /* webpackChunkName:"BorrowUse" */);
const BorrowUseUploadSuccess = () => import("./containers/repay/BorrowUse/uploadSuccess" /* webpackChunkName:"BorrowUseUploadSuccess" */);
const RepayPC = () => import("./containers/repay/RepayPC/index" /* webpackChunkName:"RepayPC" */);
const ContractList = () => import("./containers/repay/ContractList/index" /* webpackChunkName:"ContractList" */);
const ContractDetail = () => import("./containers/repay/ContractDetail/index" /* webpackChunkName:"ContractDetail" */);
const Demo = () => import("./containers/Demo/Jsbridge" /* webpackChunkName:"Jsbridge" */);
const BankCardList = () => import("./containers/repay/BankCardList/index" /* webpackChunkName:"BankCardList" */);
const BorrowRecordProof = () => import("./containers/repay/BorrowRecordProof/index" /* webpackChunkName:"BorrowRecordProof" */);
// 全部还清(提前结清)
const RepayAll = () => import("./containers/repay/RepayAll/index" /* webpackChunkName:"RepayAll" */);
const RepayDetailV2 = () => import("./containers/repay/RepayDetailV2/index" /* webpackChunkName:"RepayDetailV2" */);
const VirtualPay = () => import("./containers/repay/VirtualPay" /* webpackChunkName:"VirtualPay" */);// 好借重构二期
const LoanV3 = () => import('./containers/version2/withdraw/LoanV3/index' /* webpackChunkName:"LoanV3" */);
const FaceH5StillResult = () => import('./containers/version2/accredit/FaceStillResult/index' /* webpackChunkName:"FaceH5StillResult" */);
const VerifyListV2 = () => import('./containers/version2/withdraw/VerifyList/index' /* webpackChunkName:"VerifyListV2" */);
const EmergencyContactsV2 = () => import('./containers/version2/withdraw/EmergencyContacts/index' /* webpackChunkName:"EmergencyContactsV2" */);
const BaseInfoV2 = () => import('./containers/version2/withdraw/BaseInfo/index' /* webpackChunkName:"BaseInfoV2" */);
const WithdrawAuditFailedV2 = () => import('./containers/version2/withdraw/AuditFailed/index' /* webpackChunkName:"WithdrawAuditFailedV2" */);
const WithdrawAuditingV2 = () => import('./containers/version2/withdraw/Auditing/index' /* webpackChunkName:"WithdrawAuditingV2" */);
const WithdrawAuditSuccessV2 = () => import('./containers/version2/withdraw/AuditSuccess/index' /* webpackChunkName:"WithdrawAuditSuccessV2" */);
const AgreementDetailV2 = () => import('./containers/version2/withdraw/AgreementDetail/index' /* webpackChunkName:"AgreementDetailV2" */);
const AgreementHtmlV2 = () => import('./containers/version2/withdraw/AgreementHtml/index' /* webpackChunkName:"AgreementHtmlV2" */);
const RepayPlanPage = () => import('./containers/version2/accredit/RepayPlanPage/index' /* webpackChunkName:"RepayPlanPage" */);
// 预览多个合同 不同合同通过tab切换
const ContractHtmls = () => import('./containers/version2/withdraw/ContractHtmls/index' /* webpackChunkName:"AgreementHtmls" */);
const CheckRules = () => import('./containers/version2/withdraw/CheckRules/index' /* webpackChunkName:"CheckRules" */);
const Survey = () => import('./containers/version2/withdraw/Survey/index' /* webpackChunkName:"Survey" */);
const VipLoading = () => import('./containers/version2/withdraw/VipLoading/index' /* webpackChunkName:"VipLoading" */);
const NotReceviedSmsHelp = () => import("./containers/version2/withdraw/NotReceviedSmsHelp/index" /* webpackChunkName:"NotReceviedSmsHelp" */);
const ChangeTel = () => import("./containers/version2/withdraw/ChangeTel/index" /* webpackChunkName:"ChangeTel" */);


// 授信二期
const FaceFailV2 = () => import('./containers/version2/accredit/AppFaceFail/index' /* webpackChunkName:"FaceFailV2" */);
const FaceFailH5V2 = () => import('./containers/version2/accredit/FaceFailed/index' /* webpackChunkName:"FaceFailH5V2" */);
const OCRV2 = () => import('./containers/version2/withdraw/Ocr/index' /* webpackChunkName:"OCRV2" */);
const AuditingV2 = () => import('./containers/version2/accredit/Auditing/index' /* webpackChunkName:"Auditing" */);
const AuditFailedV2 = () => import('./containers/version2/accredit/AuditFailed/index' /* webpackChunkName:"AuditFailed" */);
const AuditSuccess = () => import('./containers/version2/accredit/AuditSuccess/index' /* webpackChunkName:"AuditSuccess" */);
const HomePageTrans = () => import('./containers/version2/accredit/HomePageTrans/index' /* webpackChunkName:"HomePageTrans" */);
const JumpLoading = () => import('./containers/version2/accredit/JumpLoading/index' /* webpackChunkName:"JumpLoading" */);
const AuditingXYF = () => import('./containers/version2/accredit/AuditingXYF/index' /* webpackChunkName:"AuditingXYF" */);
const VerifyXYFInfo = () => import('./containers/version2/accredit/verifyXYFInfo/index' /* webpackChunkName:"VerifyXYFInfo" */);


//新授信流程节点
const FormIdCardProgress = () => import('./containers/version2/accredit/FormIdCardProgress/index' /* webpackChunkName:"FormIdCardProgress" */);
const AppFaceTrans = () => import('./containers/version2/accredit/AppFaceTrans/index' /* webpackChunkName:"AppFaceTrans" */);
const FaceH5Trans = () => import('./containers/version2/accredit/FaceH5Trans/index' /* webpackChunkName:"FaceH5Trans" */);
const IdcardOcrProgress = () => import('./containers/version2/accredit/IdcardOcrProgress/index' /* webpackChunkName:"IdcardOcrProgress" */);
const AgreementProgress = () => import('./containers/version2/accredit/AgreementProgress/index' /* webpackChunkName:"AgreementProgress" */);

// 银行卡
const SupportBankListPage = () => import("./containers/bankCard/SupportLists/index" /* webpackChunkName:"SupportBankListPage" */);
const AddBankCardPage = () => import("./containers/bankCard/AddV2/addV1" /* webpackChunkName:"AddBankCardPageV2" */);
const AddBankCardPageV2 = () => import("./containers/bankCard/AddV2/index" /* webpackChunkName:"AddBankCardPageV2" */);
const NocardnumberResultV2 = () => import("./containers/bankCard/NocardnumberResultV2/index" /* webpackChunkName:"NocardnumberResultV2" */);
const NocardnumberPostFormV2 = () => import("./containers/bankCard/AddV2/NocardnumberPostForm" /* webpackChunkName:"NocardnumberPostFormV2" */);

//小微
const Attestation = () => import("./containers/xiaowei/AttestationPage" /*webpackChunkName:"Attestation" */);
const Appendix = () => import("./containers/xiaowei/AppendixPage" /*webpackChunkName:"Appendix" */);
// 会员卡页面：资金匹配卡
const FundMatchCardPage = () => import('./containers/vipCard/FundMatchCardPage/index' /* webpackChunkName:"FundMatchCardPage" */);
const FundMatchCardDetail = () => import('./containers/vipCard/FundMatchCardDetail/index' /* webpackChunkName:"FundMatchCardDetail" */);

/*
 * 提额 
 */

//** 提额指南 */
const WithdrawalGuide = () => import("./containers/raiseAmount/withdrawalGuide" /*webpackChunkName:"WithdrawalGuide"*/);
//提额降息
const AmountHall = () => import('./containers/raiseAmount/amountHall/index' /* webpackChunkName:"AmountHall" */);
const AmountHistory = () => import('./containers/raiseAmount/amountHistory/index' /* webpackChunkName:"AmountHistory" */);
const WithdrawalSuccess = () => import('./containers/raiseAmount/withdrawalSuccess/index' /* webpackChunkName:"WithdrawalSuccess" */);
const ApplyingAndFail = () => import('./containers/raiseAmount/applyingAndFail/index' /* webpackChunkName:"ApplyingAndFail" */);

declare interface RouteItem {
    name: string;
    path: string;
    exact: boolean;
    async: boolean;
    component: React.ComponentType<any> | Function;
}

const routes: RouteItem[] = [
    /**
     * 授信路径
     */
    {
        name: "AgreeContext",
        path: "/auth/agreeContext/:emsId",
        component: AgreeContext,
        exact: false,
        async: true,
    },
    /**
     * 用信路径
     */
    {
        name: "faq",
        path: "/faq",
        component: FaqList,
        exact: true,
        async: true,
    },
    {
        name: "faqDetail",
        path: "/faq/detail/:id",
        component: FaqDetail,
        exact: false,
        async: true,
    },
    {
        // 查看计算规则页面
        name: "CheckRules",
        path: "/withdraw/checkRules/loanV2/:repayType/:fundCode",
        component: CheckRules,
        exact: true,
        async: true,
    },
    /**
     * 还款
     */
    {
        name: "contractList",
        path: "/repay/contractList/:orderNo/:fundCode",
        component: ContractList,
        exact: false,
        async: true,
    },
    {
        name: "contractDetail",
        path: "/repay/contractDetail/:orderNo/:contractId",
        component: ContractDetail,
        exact: false,
        async: true,
    },
    /**
     * 测试app/h5交互
     */
    {
        name: "demo",
        path: "/demo/index",
        component: Demo,
        exact: false,
        async: true,
    },
    /**
     * 登录成功回跳页面
     */
    {
        name: "blank",
        path: "/page/transfer",
        component: BlankPage,
        exact: false,
        async: true,
    },

    // 二期授信
    {
        name: "HomePageTrans",
        path: "/home",
        component: HomePageTrans,
        exact: true,
        async: true
    }, {
        name: 'Agreement',
        path: '/accredit/agreement/auth',
        component: AgreementProgress,
        exact: true,
        async: true
    }, {
        name: 'FormIdcard',
        path: '/accredit/auth',
        component: FormIdCardProgress,
        exact: true,
        async: true
    },
    {
        name: 'IdcardOcr',
        path: '/accredit/auth/formIdcardOcr',
        component: IdcardOcrProgress,
        exact: true,
        async: true
    }, {
        name: 'auditing',
        path: '/accredit/auditingV2',
        component: AuditingV2,
        exact: true,
        async: true
    }, {
        name: 'auditFailed',
        path: '/accredit/audit/failedV2',
        component: AuditFailedV2,
        exact: true,
        async: true
    }, {
        name: 'AuditSuccess',
        path: '/accredit/audit/success',
        component: AuditSuccess,
        exact: true,
        async: true
    },
    // 信用飞授信审核中
    {
        name: 'AuditingXYF',
        path: '/accredit/auditingxyf',
        component: AuditingXYF,
        exact: true,
        async: true
    },
    // 信息填写页面
    {
        name: 'verifyXYFInfo',
        path: '/accredit/verifyxyfInfo',
        component: VerifyXYFInfo,
        exact: true,
        async: true

    },
    // 购买资金匹配卡页面
    {
        name: 'FundMatchCardPage',
        path: '/fund/match/card/buy',
        component: FundMatchCardPage,
        exact: true,
        async: true
    },
    // 资金匹配卡详情页
    {
        name: 'FundMatchCardDetail',
        path: '/fund/match/card/detail',
        component: FundMatchCardDetail,
        exact: true,
        async: true
    },
    //第三版提现页
    {
        name: "loanV3",
        path: "/loanV3/:orderNo?",
        component: LoanV3,
        exact: false,
        async: true,
    },
    {
        name: "AgreementDetailV2",
        path: "/withdraw/agreementV2/detail/:contractName/:templateId?",
        component: AgreementDetailV2,
        exact: true,
        async: true,
    },
    {
        name: "AgreementHtmlV2 ",
        path: "/withdraw/agreementV2/html/:contractName/:productId/:repayType?/:fundCode?/:timestamp?",
        component: AgreementHtmlV2,
        exact: true,
        async: true
    }, {
        // 预览多个合同 不同合同通过tab切换
        name: 'ContractHtmls ',
        path: '/withdraw/contract/htmls/:fundCode/:currentFundCode/:repayType/:creditSubject/:guaranteeCd/:timestamp?',
        component: ContractHtmls,
        exact: true,
        async: true
    },
    {
        name: 'faceV2',
        path: '/auth/faceV2/:orderNo?', // 有orderNo为用信，没有则是授信
        component: isApp() || isHaojieSDK() ? AppFaceTrans : FaceH5Trans,
        exact: true,
        async: true,
    },
    {
        name: "faceH5Result",
        path: "/auth/faceH5Result/:sourceFrom/:orderNo?", // 有orderNo为用信，没有则是授信,ab是用信实验
        component: FaceH5StillResult,
        exact: true,
        async: true,
    },
    {
        name: "nverify",
        path: "/verifyV2/list/:orderNo", // 增验列表
        component: VerifyListV2,
        exact: false,
        async: true,
    },
    {
        name: "nverifyBaseInfo", // 增验基本信息
        path: "/verifyV2/base/info/:orderNo/:detailId/:fundCode",
        component: BaseInfoV2,
        exact: false,
        async: true,
    },
    {
        name: "nemergency",
        path: "/verifyV2/emergency/contact/:orderNo/:detailId/:fundCode", // 紧急联系人
        component: EmergencyContactsV2,
        exact: true,
        async: true,
    },
    {
        name: "faceFailV2",
        path: "/auth/failV2/face/:errCode/:orderNo?", // 有orderNo为用信，没有则是授信
        component: isApp() || isHaojieSDK() ? FaceFailV2 : FaceFailH5V2,
        exact: true,
        async: true,
    },
    {
        name: "OcrV2",
        path: "/withdraw/ocr/v2/:orderNo",
        component: OCRV2,
        exact: true,
        async: true,
    },
    {
        name: "withdrawAuditFailedV2", // 二期 提现审核失败页
        path: "/withdrawV2/audit/failed/:orderNo",
        component: WithdrawAuditFailedV2,
        exact: false,
        async: true,
    }, {
        name: 'withdrawAuditingV2',       // 二期 提现审核中
        path: '/withdrawV2/auditing/:orderNo',
        component: WithdrawAuditingV2,
        exact: true,
        async: true,
    },
    {
        name: "withdrawAuditSuccessV2", // 二期 提现审核成功
        path: "/withdrawV2/audit/success/:orderNo",
        component: WithdrawAuditSuccessV2,
        exact: false,
        async: true,
    }, {
        name: 'survey',  // 调查问卷
        path: '/withdrawV2/survey/:orderNo/:type/:loanType/:pageCode?',
        component: Survey,
        exact: true,
        async: true
    }, {
        name: 'vipLoading',  // 购买会员成功回跳页面 payType支付标示，pageCode返回的页面，
        path: '/withdrawV2/vip/:payType/:pageCode/:orderNo?',
        component: VipLoading,
        exact: true,
        async: true

    },
    {
        name: "notReceviedSms", // 收不到验证码帮助页 urlHasOrderNo和urlHasOrderNo是为了区分提现页是否是从增验列表的“去修改”点进去的
        path: "/notReceviedSms/help/:orderId",
        component: NotReceviedSmsHelp,
        exact: true,
        async: true,
    },
    {
        name: "changeTel", // 更换手机号页面
        path: "/changeTel/:fundCode/:bankCardId/:orderNo",
        component: ChangeTel,
        exact: true,
        async: true,
    },

    // 好借二期还款，只是换了地址
    {
        name: "nrepayResult", // 还款结果
        path: "/repayV2/result/:repayId",
        component: RepayResult,
        exact: false,
        async: true,
    },
    {
        name: "nborrowRecord", // 借款记录
        path: "/repayV2/borrow/record",
        component: BorrowRecord,
        exact: true,
        async: true,
    },
    {
        name: "nborrowDetail", // 借款详情
        path: "/repayV2/borrow/detail/:orderNo",
        component: BorrowDetail,
        exact: false,
        async: true,
    },
    {
        name: "nborrowUse", // 借款用途证明
        path: "/repayV2/borrow/borrowUse/:orderNo",
        component: BorrowUse,
        exact: false,
        async: true,
    },
    {
        name: "nborrowUseUploadSuccess",
        path: "/repayV2/borrow/borrowUseUploadSuccess/:orderNo",
        component: BorrowUseUploadSuccess,
        exact: false,
        async: true,
    },
    // 多借据上线后理论上只有好借app第一版的时候才有可能访问到这个页面 所以直接展示新版还款详情页内容即可  from是页面来源 native：1, h5：2
    {
        name: "nrepayTerm",
        path: "/repayV2/term/:orderNo/:term/:from", // 还款详情 单期
        component: RepayDetailV2,
        exact: true,
        async: true,
    },
    {
        // 多借据上线后理论上只有好借app第一版的时候才有可能访问到这个页面 所以直接展示新版全部结清页内容即可
        // 全部还清（提前结清） 因为好借一期的时候 好借APP的首页是native的页面 里面有全部结清和还款详情的入口 所以这个url在多借据需求中不能删除或改动
        name: "nrepayAll",
        path: "/repayV2/all/:orderNo/:term/:from",
        component: RepayAll,
        exact: true,
        async: true,
    },
    {
        name: "BankCardListV2",
        path: "/repayV2/bank/card/list/:fundCode/:payBackFlag/:orderNo?",
        component: BankCardList,
        exact: true,
        async: true,
    },
    {
        name: "pcRepayV2",
        path: "/repayV2/pcRepay/:orderNo/:term",
        component: RepayPC,
        exact: false,
        async: true,
    },
    {
        name: "borrowRecordProof", // 结清证明列表
        path: "/repayV2/borrow/recordProof",
        component: BorrowRecordProof,
        exact: true,
        async: true,
    },
    {
        name: "RepayAll", // 全部还清（提前结清） 多借据
        path: "/repayV2/all/:orderNo",
        component: RepayAll,
        exact: true,
        async: true,
    },
    {
        name: "RepayDetailV2", // 还款详情 多借据需求
        path: "/repayV2/detail",
        component: RepayDetailV2,
        exact: true,
        async: true,
    },
    {
        name: "VirtualPay", // 中银的虚拟收银台
        path: "/repayV2/virtualPay/:orderNo/:repayType/:fundCode/:termNo?",
        component: VirtualPay,
        exact: true,
        async: true,
    },
    // 添加银行卡 支付包助贷版本
    {
        name: "supportBankList",
        path: "/bank/card/support/:orderNo/:fundCode/:payBackFlag/:from?",
        component: SupportBankListPage,
        exact: true,
        async: true,
    },
    {
        name: "addBankCardPage",
        path: "/bank/card/add/:from/:fundCode/:payBackFlag/:orderNo/:bankCardId?",
        component: AddBankCardPage,
        exact: true,
        async: true,
    },
    {
        name: "addBankCardPageV2",
        path: "/bank/card/addV2/:from/:fundCode/:payBackFlag/:orderNo/:openImageUrl?/:bankCardId?",
        component: AddBankCardPageV2,
        exact: true,
        async: true,
    },
    {
        name: "nocardnumberResult",
        path: "/bank/card/nocardnumber/result/:from/:fundCode/:payBackFlag/:bindNo",
        component: NocardnumberResultV2,
        exact: true,
        async: true,
    },
    {
        name: "nocardnumberResultV2",
        path: "/bank/card/nocardnumberV2/result/:from/:fundCode/:payBackFlag/:bindNo",
        component: NocardnumberResultV2,
        exact: true,
        async: true,
    },
    {
        name: "nocardnumberPostForm",
        path: "/bank/card/nocardnumber/postform/:bankId/:bankName/:mobile/:channelCode/:from/:payBackFlag",
        component: NocardnumberPostFormV2,
        exact: true,
        async: true,
    },
    {
        name: "nocardnumberPostFormV2",
        path: "/bank/card/nocardnumberV2/postform/:bankId/:bankName/:mobile/:channelCode/:from/:payBackFlag",
        component: NocardnumberPostFormV2,
        exact: true,
        async: true,
    },
    {
        name: "jumpLoading",
        path: "/jump/loading", // 直跳流程，逻辑和首页点击一样
        component: JumpLoading,
        exact: true,
        async: true,
    },

    //小微企业主认证
    {
        name: "attestation",
        path: "/xiaowei/attestation",
        component: Attestation,
        exact: true,
        async: true,
    },
    {
        name: "appendix",
        path: "/xiaowei/appendix/:regno/:entname?",
        component: Appendix,
        exact: true,
        async: true,
    },
    {
        name: "RepayPlanPage", //还款详情
        path: "/repayPlan",
        component: RepayPlanPage,
        exact: false,
        async: true,
    },
    {
        name: "WithdrawalGuide",
        path: "/raiseAmount/WithdrawalGuide/:type?",
        component: WithdrawalGuide,
        exact: true,
        async: true,
    },
    //提额降息中心
    {
        name: "amountHall",
        path: "/amount/hall",
        component: AmountHall,
        exact: true,
        async: true,
    },
    //提额历史
    {
        name: "amountHistory",
        path: "/amount/history",
        component: AmountHistory,
        exact: true,
        async: true,
    },
    //提额成功
    {
        name: "amount",
        path: "/amount/success/:totalAmount/:increaseAmount",
        component: WithdrawalSuccess,
        exact: true,
        async: true,
    },
    {
        name: "ApplyingAndFail",
        path: "/amount/result/:status",
        component: ApplyingAndFail,
        exact: true,
        async: true,

    }
];

export default routes;
